<template>
  <div id="nav" class="navbar navbar-expand-lg navbar-dark bg-dark">
    <div class="container-fluid">
      <a class="navbar-brand" href="/">Tlapaleria Piedra</a>
      <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="collapse navbar-collapse" id="navbarSupportedContent">
        <ul class="navbar-nav me-auto mb-2 mb-lg-0">
          <li class="nav-item">
            <router-link class="nav-link" to="/">Inicio</router-link>
          </li>
          <li class="nav-item">
            <router-link class="nav-link" to="/productos">Productos</router-link>
          </li>
          <template  v-if="user === true">
            <!-- <li class="nav-item">
              <router-link class="nav-link" to="/adminPanel">Panel de administrador</router-link>
            </li> -->
            <li class="nav-item">
              <router-link class="nav-link" to="/venta">Venta</router-link>
            </li>
          </template>
        </ul>
        <div  v-if="user === true">
          <button class="btn btn-outline-danger" @click="logout">Cerrar sesión</button>
        </div>
        <div>
          <!-- Carrito 
          <carritoComponent />-->
        </div>
      </div>
    </div>
  </div>
  <router-view/>
</template>

<script>

//import carritoComponent from "./components/carritoComponent.vue"

export default {
  data(){
    return{
      user:false,
    }
  },
  components:{
    //carritoComponent
  },
  created(){
    this.checklogin()
  },
  methods:{
    checklogin(){
      if(localStorage.getItem('user') == "true"){
        this.user = true
      }
    },
    logout(){
      localStorage.clear()
    }
  },
}
</script>

<style>
</style>
